export const serverUrl = "https://tayyab.foreachsol.com:9000";
export const trackingBaseUrl = "https://admin.rcsxpress.com/api";
// export const serverUrl = "http://localhost:3001";
